module.exports = __webpack_public_path__ + "img/full6-min.1af2fba3.png";